import * as React from "react";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  CommonInputProps,
  StyledBox,
  StyledBoxCode,
  StyledBoxCountry,
  StyledBoxLabel,
  StyledBoxName,
  StyledFormControlSlot,
  StyledImg,
  StyledInputAdornment,
  StyledLabelSpan,
  StyledTextField,
} from "./style";
import { IconButton, InputAdornment } from "@mui/material";
import eye from "../../../assets/images/eye.png";
import drop from "../../../assets/images/Icon.png";
import { countryWithCode } from "./constant";

import CountryDropdown from "../../../components/common/country-dropdown/CountryDropdown";

const compactHelperSx = {
  minHeight: "20px",
  margin: "3px 0 0",
  lineHeight: "20px",
  display: "block",
};

const tableHelperSx = {
  minHeight: "18px",
  height: "18px",
  maxHeight: "18px",
  margin: "2px 0 0",
  lineHeight: "18px",
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
};

export default function CustomInput(props) {
  const {
    customLabel,
    isprofile,
    formGrid,
    tableField,
    profileForm,
    required,
    type,
    isPhoneNumber = false,
    currentCountryCode,
    setCurrentCountryCode,
    fontSize,
    color,
    startAdornment,
    endAdornment,
    multiline,
    rows,
    issize,
    placeholder,
    numberNotAllow = false,
    textAlign,
    helperText,
    error,
    ...rest
  } = props;
  const [showPassword, setShowPassword] = React.useState(false);
  const dateInputRef = React.useRef(null);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const currentCountry = countryWithCode.find(
    (val) => val.prefix === currentCountryCode
  );
  const useCompactHelper = formGrid || tableField || profileForm;
  return (
    <StyledBox
      noValidate
      autoComplete="off"
      isprofile={isprofile}
      issize={issize}
      formGrid={formGrid}
      tableField={tableField}
      profileForm={profileForm}
      {...(profileForm ? { "data-profile-address-field": "" } : {})}
    >
      {customLabel && (
        <StyledBoxLabel color={color} fontSize={fontSize} formGrid={formGrid}>
          {customLabel}
          <StyledLabelSpan>{required ? "*" : ""}</StyledLabelSpan>
        </StyledBoxLabel>
      )}
      <StyledFormControlSlot
        onClick={() => {
          if (type === "date" && dateInputRef.current) {
            try {
              dateInputRef.current.showPicker();
            } catch (_) {}
          }
        }}
      >
      <StyledTextField
        isprofile={isprofile}
        formGrid={formGrid}
        tableField={tableField}
        profileForm={profileForm}
        placeholder={placeholder}
        inputRef={type === "date" ? dateInputRef : undefined}
        type={
          type === "password"
            ? !showPassword
              ? "password"
              : "text"
            : type || "text"
        }
        variant="outlined"
        multiline={multiline}
        rows={rows}
        onKeyDown={(e) => {
          if (numberNotAllow && /[0-9]/.test(e.key)) {
            e.preventDefault();
          }
        }}
        isDollar={startAdornment}
        InputProps={{
          ...CommonInputProps,
          endAdornment:
            type === "password" ? (
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} edge="end">
                  {showPassword ? (
                    <img
                      loading="lazy"
                      width={20}
                      height={20}
                      src={eye}
                      alt="eye"
                    />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            ) : (
              endAdornment
            ),
          startAdornment: isPhoneNumber ? (
            <StyledInputAdornment position="start">
              <StyledBoxName>{currentCountry?.code}</StyledBoxName>
              <StyledImg
                src={drop}
                height={10}
                alt="dropdown-arrow"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
              />
              {isDropdownOpen && (
                <StyledBoxCountry>
                  <CountryDropdown
                    setIsDropdownOpen={setIsDropdownOpen}
                    setCurrentCountryCode={setCurrentCountryCode}
                  />
                </StyledBoxCountry>
              )}
              <StyledBoxCode>{currentCountry?.prefix}</StyledBoxCode>
            </StyledInputAdornment>
          ) : (
            startAdornment
          ),
        }}
         inputProps={{
    ...(type === "date" ? { max: rest.max, min: rest.min } : {}),
    style: multiline
      ? { textAlign: "left", verticalAlign: "top" } // 👈 force text top-left
      : {},
  }}
        error={error}
        helperText={useCompactHelper ? helperText || "\u00a0" : helperText}
        FormHelperTextProps={
          useCompactHelper
            ? {
                sx: tableField ? tableHelperSx : compactHelperSx,
                style: !helperText ? { visibility: "hidden" } : undefined,
              }
            : undefined
        }
        {...rest}
      />
      </StyledFormControlSlot>
    </StyledBox>
  );
}
